import React from 'react';
import uuid from 'react-uuid';
import '../css/TestScripts.css';
import CustomMessageForm from '../CustomMessageForm.js';
import TestScriptButtons from '../TestScriptButtons.js';
import UserRefreshForm from '../UserRefreshForm.js';
import ActionRequestForm from '../components/ActionRequestForm.js';
import CreateTransmissionStatus from '../TransmissionStatusForm.js';
import InvoicesForm from '../TestClockForm.js';
import InvoiceDetails from '../components/InvoiceDetailsModal.js';
import { onRequestFailure } from '../components/AuthHandler.js';
import { AddBox, IndeterminateCheckBox } from '@material-ui/icons';
import { IconButton, Tooltip } from '@mui/material';

const encodeNestedObjects = (params, prefix) => {
  var items = [];
  for (var field in params) {
    var key = prefix + "[" + field + "]";
    var type = typeof params[field];
    switch (type) {
      case "object":
        if (params[field] == null) {
          items.push(encodeURIComponent(key) + "=");
        }
        else {
          items = items.concat(encodeNestedObjects(params[field], key));
        }
        break;
      default:
        items.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[field]));
        break;
    }
  }

  return items.filter(x => x !== "").join("&");
}

const encodeFormData = (data) => {
  var url = Object.keys(data)
    .map(key => {
      if (key == "form_data" && data[key] !== "") {
        return encodeNestedObjects(JSON.parse(data[key]), key);
      }
      else {
        return encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      }
    })
    .join('&')
  return url;
}

class TestScripts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 'messageApis',
      token: localStorage.getItem("token"),
      responseMessages: [],
      showApiKeyInput: false,
      clientKeys: [],
      clientKey: "",
      clientKeyInput: "",
      showSuggestions: false,
      isLoading: false,
      selectedInvoice: null,
      expandedPayloads: {},
      payloads: {}
    }
    if (localStorage.getItem('apiKey') != null) {
      this.state['apiKey'] = localStorage.getItem('apiKey');
    }
    // bind methods
    this.makeFetchRequest = this.makeFetchRequest.bind(this);
    this.makeMessageRequest = this.makeMessageRequest.bind(this);
    this.clearResponseLog = this.clearResponseLog.bind(this);
    this.handleClientChange = this.handleClientChange.bind(this);
    this.fetchClientKeys = this.fetchClientKeys.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.handleClientInputChange = this.handleClientInputChange.bind(this);
    this.handleClientSelect = this.handleClientSelect.bind(this);
    this.handleInvoiceSelect = this.handleInvoiceSelect.bind(this);
    this.togglePayloadDisplay = this.togglePayloadDisplay.bind(this);

    // tts message texts
    this.TtsText = {
      normalTTS: "Your trailer, 1 6 5 0 0 3, is reporting a reefer alarm. Code 2 0 0 0 0 1. LOW FUEL LEVEL WARNING. Fuel level is 27.0 gallons.",
      longTTS: "Are you listening to me? ".repeat(14) + "You reached the end of message. Congratulations!!!",
      pokemonTTS: "I want to be the very best, Like no one ever was. To catch them is my real test, To train them is my cause. I will travel across the land, Searching far and wide. Each Pokemon to understand The power thats inside. Pokemon. Gotta catch em all. Its you and me, I know its my destiny.",
      commonAbrevTTS: "The time is 11:00 pm the 17th of march. Order #149. It takes 14 hr to cook chicken. I weigh 14 lb and my cat weighs 90 kg",
      spanishTTS: "Tienes una nueva orden asignada: 724890"
    };
  }

  componentDidMount() {
    // Fetch client keys when component mounts if using token
    if (this.state.token && this.state.clientKeys.length === 0) {
      this.fetchClientKeys();
    }
  }

  fetchClientKeys() {
    this.setState({ isLoading: true });
    const endpoint = "https://squid-fortress-staging.eleostech.com/internal/client_groups/eleos";
    const headers = {
      "Authorization": `Bearer ${this.state.token}`,
      "Content-Type": "application/json"
    };

    fetch(endpoint, { headers })
      .then(response => {
        if (response.status === 403 || response.status === 401) {
          onRequestFailure();
          throw new Error(`${response.status} ${response.statusText} - Token cleared`);
        }
        if (!response.ok) throw new Error(`Failed to fetch from ${endpoint}: ${response.status}`);
        return response.json();
      })
      .then(data => {
        const allKeys = data.clients.map(client => client.key);
        const defaultKey = allKeys.includes('reference-qa') ? 'reference-qa' : (allKeys.length > 0 ? allKeys[0] : "");
        this.setState({
          clientKeys: allKeys,
          clientKey: defaultKey,
          clientKeyInput: defaultKey,
          isLoading: false
        });
      })
      .catch(e => {
        console.error(`Error Retrieving client keys: ${e}`);
        this.setState({ clientKeys: [], clientKey: "", clientKeyInput: "", isLoading: false });
      });
  }

  togglePayloadDisplay(requestId) {
    this.setState(prevState => ({
      expandedPayloads: {
        ...prevState.expandedPayloads,
        [requestId]: !prevState.expandedPayloads[requestId]
      }
    }));
  }

  makeFetchRequest(options, endPoint, payload = null) {
    var newRespMessage;
    const handle = uuid();
    const url = `https://squid-fortress-staging.eleostech.com/api/${endPoint}/${handle}`;
    var date = new Date();
    var time = `[${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}]`;
    
    // Store payload if it exists
    if (payload) {
      this.setState(prevState => ({
        payloads: {
          ...prevState.payloads,
          [handle]: payload
        }
      }));
    }

    // Add message with request ID
    this.setState({ 
      responseMessages: this.state.responseMessages.concat([{
        id: handle,
        time: time,
        text: `Request: ${options.method} ${url}`,
        hasPayload: !!payload
      }]) 
    });

    fetch(url, options)
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          onRequestFailure();
          throw new Error(`${response.status} ${response.statusText}`);
        }
        if (response.ok) {
          localStorage.setItem('apiKey', this.state.apiKey);
        }
        time = `[${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}]`;
        newRespMessage = `\u00A0Response: ${response.status}(${response.statusText})`;
        this.setState({ 
          responseMessages: this.state.responseMessages.concat([{ 
            id: uuid(), 
            time: time,
            text: newRespMessage,
            hasPayload: false 
          }]) 
        });
      })
      .catch((e) => {
        console.log(e);
        time = `[${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}]`;
        newRespMessage = ` Error sending request: ${e}`;
        this.setState({ 
          responseMessages: this.state.responseMessages.concat([{ 
            id: uuid(), 
            time: time,
            text: newRespMessage,
            hasPayload: false 
          }]) 
        });
      });
  }

  makeMessageRequest(data) {
    var numRequests = data.numRequests || 1;
    let requestData = JSON.parse(JSON.stringify(data));
    if (requestData.alert === false) delete requestData.sound;
    delete requestData.numRequests;
    requestData.message_type = requestData.message_type || "text";
    requestData.direction = requestData.direction || "outbound";
    requestData.body = requestData.body || "test";

    if (requestData.message_type === "form" && !requestData.form_code) {
      alert("Form Code cannot be empty");
      return;
    }

    if (requestData.message_type === "form") {
      delete requestData.body;
      if (!requestData.form_data) {
        alert("Form Data cannot be empty");
        return;
      }
      try {
        JSON.parse(requestData.form_data);
      } catch {
        alert("Incorrect JSON for Form Data");
        return;
      }
    }

    const options = this.state.showApiKeyInput && this.state.apiKey
      ? ({
        method: 'PUT',
        headers: {
          "Authorization": `Key key=${this.state.apiKey}`,
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        body: encodeFormData(requestData)
      })
      : ({
        method: 'PUT',
        headers: {
          "Authorization": `Bearer ${this.state.token}`,
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Eleos-Admin-Client-Key": this.state.clientKey || ""
        },
        body: encodeFormData(requestData)
      });

    for (var i = 0; i < numRequests; i++) {
      this.makeFetchRequest(options, "v1/messages", requestData);
    }
  }

  handleClientChange(event) {
    this.setState({ clientKey: event.target.value })
  }

  handleClientInputChange(event) {
    const value = event.target.value;
    this.setState({
      clientKeyInput: value,
      clientKey: value,
      showSuggestions: true
    });
  }

  handleClientSelect(key) {
    this.setState({
      clientKey: key,
      clientKeyInput: key,
      showSuggestions: false
    });
  }

  clearResponseLog() {
    this.setState({ responseMessages: [], payloads: {}, expandedPayloads: {} });
  }

  handleResponse = (message) => {
    this.setState(prevState => ({
      responseMessages: prevState.responseMessages.concat([{ id: uuid(), text: message, hasPayload: false }])
    }));
  };

  toggleTab(tab) {
    this.setState({ selectedTab: tab });
  }

  handleInvoiceSelect(invoice) {
    this.setState({ selectedInvoice: invoice });
  }

  render() {
    const { responseMessages, selectedTab, clientKeys, clientKeyInput, showSuggestions, expandedPayloads, payloads } = this.state;

    const filteredSuggestions = clientKeys
      .filter(key => key.toLowerCase().includes(clientKeyInput.toLowerCase()))
      .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

    const getResponseStyle = (message) => {
      if (message.text.includes("Response: 200")) {
        return { color: "#28a745" };
      } else if (
        message.text.includes("Response: 400") ||
        message.text.includes("Response: 401") ||
        message.text.includes("Response: 403") ||
        message.text.includes("Response: 404") ||
        message.text.includes("Response: 500") ||
        message.text.includes("Response: Error")
      ) {
        return { color: "#dc3545" };
      }
      return {};
    };
    return (
      <div className="test-scripts-container">
        <header className='test-scripts-header'>
          <h1>API Test Dashboard</h1>
        </header>
        {this.state.clientKeys.length > 0 && (
          <section className="controls-section">
            <div className="input-group">
              {this.state.isLoading && (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <p style={{ marginRight: '1em' }}>Loading Clients...</p>
                  <div className="loading-indicator"></div>
                </div>
              )}
              <label className="input-label client-key-search">
                <span>Client Key:</span>
                <div className="autocomplete-container" style={{ marginLeft: '1em' }}>
                  <input
                    type="text"
                    name="clientKey"
                    value={this.state.clientKeyInput}
                    onChange={this.handleClientInputChange}
                    onFocus={() => this.setState({ showSuggestions: true })}
                    onBlur={() => setTimeout(() => this.setState({ showSuggestions: false }), 200)}
                    className="text-input uniform-width"
                    placeholder="Search client key..."
                  />
                  {showSuggestions && filteredSuggestions.length > 0 && (
                    <ul className="suggestions-list">
                      {filteredSuggestions.map(key => (
                        <li
                          key={key}
                          className="suggestion-item"
                          onMouseDown={() => this.handleClientSelect(key)}
                        >
                          {key}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </label>
            </div>
          </section>
        )}
        <div className="split-container">
          <div className="left-panel">
            <section className='tabs-section'>
              <ul className='tabs'>
                <li className={selectedTab === 'messageApis' ? 'active' : ''} onClick={() => this.toggleTab('messageApis')}>Scripts</li>
                <li className={selectedTab === 'customMessage' ? 'active' : ''} onClick={() => this.toggleTab('customMessage')}>Custom Message</li>
                <li className={selectedTab === 'userRefresh' ? 'active' : ''} onClick={() => this.toggleTab('userRefresh')}>User Refresh</li>
                <li className={selectedTab === 'actionRequest' ? 'active' : ''} onClick={() => this.toggleTab('actionRequest')}>Action Request</li>
                <li className={selectedTab === 'transmissionStatus' ? 'active' : ''} onClick={() => this.toggleTab('transmissionStatus')}>Transmission Status</li>
                <li className={selectedTab === 'testClock' ? 'active' : ''} onClick={() => this.toggleTab('testClock')}>Test Clock</li> 
              </ul>
            </section>

            <section className='tab-content'>
              {selectedTab === 'messageApis' && (
                <div className="message-request-section">
                  <section className='test-buttons-section'>
                    <TestScriptButtons MessageFunction={this.makeMessageRequest} TtsText={this.TtsText} />
                  </section>
                </div>
              )}

              {selectedTab === 'customMessage' && (
                <div className="message-request-section">
                  <section className='custom-message-section'>
                    <CustomMessageForm MessageFunction={this.makeMessageRequest} />
                  </section>
                </div>
              )}

              {selectedTab === 'userRefresh' && (
                <div className="user-refresh-section">
                  <UserRefreshForm
                    token={this.state.token}
                    clientKey={this.state.clientKey}
                    onResponse={this.handleResponse}
                  />
                </div>
              )}

              {selectedTab === 'actionRequest' && (
                <div className="action-request-section">
                  <ActionRequestForm
                    token={this.state.token}
                    clientKey={this.state.clientKey}
                    onResponse={this.handleResponse}
                  />
                </div>
              )}

              {selectedTab === 'transmissionStatus' && (
                <div className="transmission-section">
                  <CreateTransmissionStatus onResponse={this.handleResponse} />
                </div>
              )}

              {selectedTab === 'testClock' && (
                <div className='test-clock-section'>
                  <InvoicesForm onResponse={this.handleResponse} onInvoiceSelect={this.handleInvoiceSelect} />
                </div>
              )}
            </section>
          </div>
          <div className="right-panel">
            {selectedTab === "testClock" ? (
              <section className="invoice-details-section">
                <InvoiceDetails invoice={this.state.selectedInvoice} />
              </section>
            ) : (
              <section className="response-section">
                <div style={{ justifyContent: "center", display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <h3>Response Logs</h3>
                  {this.state.responseMessages.length > 0 && (
                    <button onClick={this.clearResponseLog} className="clear-button">
                      Clear
                    </button>
                  )}
                </div>
                <div className="response-container">
                  {responseMessages.length === 0 ? (
                    <p className="no-logs">No logs yet.</p>
                  ) : (
                    responseMessages.map((message, index) => (
                      <div key={message.id} className="response-item" style={getResponseStyle(message)}>
                          <div style={{display: 'flex', alignItems:'center'}}>
                            <span className='response-time'>{message.time}</span>
                            {message.hasPayload && (
                              <Tooltip title={expandedPayloads[message.id] ? "Collapse Payload" : "Expand Payload"}>
                                <IconButton sx={{mx:'0.5rem'}} color="primary" size='small' onClick={() => this.togglePayloadDisplay(message.id)}>
                                  {expandedPayloads[message.id] ? <IndeterminateCheckBox style={{fontSize:'1.2rem'}} /> : <AddBox style={{fontSize:'1.2rem'}} />}
                                </IconButton>
                              </Tooltip>
                            )}
                            <span>{message.text}</span>
                          </div>
                          {message.hasPayload && expandedPayloads[message.id] && (
                              <div className='payload'>
                                <pre style={{ margin: 0, fontSize: '12px' }}>
                                  {JSON.stringify(payloads[message.id], null, 2)}
                                </pre>
                              </div>
                            )}
                      </div>
                    ))
                  )}
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export { TestScripts }
